import { TableCell } from "@mui/material";
import { FC, Fragment } from "react";
import Permissions from "../../constants/permissions";
import { FlowOutput, Upload } from "../../graphql/types";
import { getFormattedReportDate } from "../../lib/Util";
import { UploadAbandonButton } from "../AbandonButton";
import { DetailContainerRow, DownloadsForUpload } from "../common/FileDetailViews";
import IconCopy from "../common/IconCopy";
import { HumanDate } from "../Date";
import { IfPermission } from "../Permissions";
import { StatusTd, TableRowHover } from "../ui/muiTables";
import { UploadStatusIcon } from "../UploadStatusIcon";

interface UploadRowProps {
  upload: Upload | FlowOutput;
  onClick: (id: string) => void;
  selected?: boolean;
  allowViewDownloads?: boolean;
  showDetail?: boolean;
}

const canUploadBeAbandoned = (status: string | null | undefined) => {
  return ["preparing", "queued", "uploading", "loading", "retrying", "failed"].indexOf(status ?? "") > -1;
};

const UploadRow: FC<UploadRowProps> = ({ upload, onClick, selected, allowViewDownloads, showDetail }) => (
  <Fragment>
    <TableRowHover
      key={upload.id}
      disableHover={!allowViewDownloads}
      onClick={() => allowViewDownloads && onClick(upload.id)}
      className={selected ? "selected" : ""}
    >
      <TableCell data-testid="report-date-time">
        {getFormattedReportDate(upload.report_datetime?.iso || null, true)}
      </TableCell>
      <TableCell>
        <HumanDate date={upload.created} />
      </TableCell>
      <TableCell>
        <HumanDate date={upload.started} />
      </TableCell>
      <TableCell>
        <HumanDate date={upload.finished} />
      </TableCell>
      <TableCell>
        <div className="upload-project-name" data-testid="upload-project-name">
          {upload.project} - {upload.name}
        </div>
        <IconCopy tooltip={`Uploads ID: ${upload.id}`} clipboard={`Uploads ID: ${upload.id}`} />
      </TableCell>
      <TableCell>
        <div>{upload?.handle?.destination}</div>
      </TableCell>
      <TableCell>
        <IfPermission permission={Permissions.ManagePipelines}>
          {canUploadBeAbandoned(upload.status) ? <UploadAbandonButton id={upload.id} onClick={() => {}} /> : null}
        </IfPermission>
      </TableCell>
      <StatusTd>
        {upload.status ? <UploadStatusIcon status={upload.status} rowCount={upload.row_count} /> : null}
      </StatusTd>
    </TableRowHover>
    {showDetail ? (
      <DetailContainerRow key={`downloads_for_${upload.id}`}>
        <td colSpan={7}>
          <DownloadsForUpload upload_id={upload.id} />
        </td>
      </DetailContainerRow>
    ) : null}
  </Fragment>
);

export { UploadRow };
